import FieldsSettings from 'routes/FieldsSettings/FieldsSettings';

export default FieldsSettings;
